import React from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useDeleteSnapshotCollectionMutation } from "../../snapshotCollection.api";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";
import { toast } from "react-toastify";
import { getCollectionLockMessage } from "@/views/contract-families/pipeline/pipelineErrors";

interface Props {
  setIsOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  snapshotCollection: SnapshotCollection;
}

export const RemoveCollectionModal: React.FC<Props> = ({ isOpen, setIsOpen, snapshotCollection }) => {
  const [deleteSnapshotCollection, { isLoading }] = useDeleteSnapshotCollectionMutation();

  const onClick = async () => {
    try {
      await deleteSnapshotCollection({ id: snapshotCollection.id }).unwrap();
    } catch (error) {
      // A refused delete names its reason; anything else gets a neutral message.
      toast.error(getCollectionLockMessage(error, "The SnapShot collection could not be deleted."));
      return;
    }

    setIsOpen(false);
    toast.success("SnapShot collection deleted");
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete SnapShot collection</DialogTitle>
        </DialogHeader>

        <p>
          Are you sure you want to delete the SnapShot collection <strong>{snapshotCollection.name}</strong>? This
          action cannot be undone.
        </p>

        <DialogFooter className="mt-4">
          <Button type="button" variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={onClick} disabled={isLoading}>
            {isLoading ? "Deleting.." : "Confirm Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
